import { Button, ChevronLeftIcon } from '@iheartjane/reefer';

import styles from './legacyMenuProductCard.module.css';

interface Props {
  autoFocus?: boolean;
  onClick: () => void;
  productName?: string;
}

export const MenuProductCardBackButton = ({
  autoFocus = false,
  onClick,
  productName,
}: Props) => {
  return (
    <Button.Icon
      className={styles['backButton']}
      onClick={onClick}
      ariaLabel={`Return to ${productName ?? 'product'} details`}
      icon={<ChevronLeftIcon size="md" color="grays-mid" />}
      autoFocus={autoFocus}
    />
  );
};
